<template><div><h1>md5</h1>
<div class="tip">
<p>该工具直接依赖于 <a href="https://github.com/blueimp/JavaScript-MD5">blueimp-md5</a></p>
<p>注意: <code>md5</code>是消息摘要算法并非加密算法，用于需要加密的场景会有安全问题。</p>
</div>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { md5 } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

md5(<span class="hljs-string">'VUX'</span>)
</code></pre>
</div></template><script>
export default {
  head: {"title":"md5 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// md5-179.vue?0bf142d2